<div class="onboarding-step-wrapper">
    <h2>Enable financial services</h2>
    <div class="onboarding-blurb">
        <p>
            The financial feature of ACABIM is optional. If enabled, it will make financial-related features such as
            budgeting and Long-term Maintenance (LTM) Plan available, which are useful in ACAFM for managing the operation
            of your projects.
        </p>
    </div>
    <ng-container *ngIf="!isLoading else showLoader">
        <div class="onboarding-prompt-wrapper">
            <ng-container *ngIf="active else showInactive">
                <p class="onboarding-prompt">Financial services are enabled.<br/>Do you want to disable financial services?</p>
                <button (click)="submit(false)" class="cas-button-action">Disable</button>
            </ng-container>

            <ng-template #showInactive>
                <p class="onboarding-prompt">Financial services are disabled.<br/>Do you want to enable financial services?</p>
                <button (click)="submit(true)" class="cas-button-action">Enable</button>
            </ng-template>
        </div>
    </ng-container>

    <ng-template #showLoader>
        <acabim-loading-view></acabim-loading-view>
    </ng-template>

</div>
